var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "url(#pattern0_592_565)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_592_565",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_592_565",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_592_565",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAlZJREFUWIW9l8+LTlEYx7/njiEbZWSB5UhiMRSzmZkyC0UaG4kpKf+AxMKGhViMpYWNpvzMz5UixJtmNlJjRqKEYoHZMLJAJuZjcd/J05n73ve593p9N+89t/N9ns953nuee25QjoA+SQOS+iWtkLRU0mdJk5JGJd2SVAshzOTFKSxgE/AIn54BA/8qcQAOA7+dya3OAPOL5gw2uaTLknZnzHsnaVzSJ0mLJXVJWpUx76GkrSGEn0VBBBzLWNUdoLvB/LXAtQzPuTLJe4AZE+QXcMDp3QP8iCB2FAUYiQIcKugfjBbwGmj3mjdGyR8Uov8b52IUZ5vXGP/3fSUBVkZVOO812vJPAkkZgHqsCRPrhceTSFpuxk8rdrUJc93pWUwiaYkZT1VILqVtelYLPIYkStpREcD6pz3VTCR9MOMu0o5YVuvN9SuPIZE0YsbLJPWUyQx0Slpnbo15jd3RNrxfEuBCFGdLEfNoZHa1YePfFfWAN4W2M9DL3HfBfqd3EPgeLWB7kQXMBjrBXN0GNjSYvwa4EoEDvAc6gDZPXnseSCRdlbQzY95bSU+UbtlFSh+21Tlxvyh9wGuS9oYQvnlgBCTAyYxKeHQ3oxoANWChC8CA9ANjzsQvqZ8JgXs5cK7OGFejFzgFPAamgOn67zhwGtiMaVzA8xzQm3jPCGUF7GtSrRvAvFZDHGkCcR3nDqkCkbWlrc5S4dzhhRhqAjFMtRdfU4BA+qDm6XjLAAzEcA7Ax5YC1CES4FIDgKMtB6hDtJG+N6yG/ktyA9FO+u3wFTg4e/8PPyxogfLHOZQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMagnifier);
export default __webpack_public_path__ + "static/media/e-magnifier.49e9f78e858f37fd2403e8f50237cd89.svg";
export { ForwardRef as ReactComponent };